// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool } from 'prop-types'

const LoadingIcon = ({ loading }) => (
  loading
    ? (
      <div className={'loading-icon'}>
        <i className={'fa fa-spinner fa-spin'} />
      </div>
    ) : null
)

LoadingIcon.propTypes = {
  loading: bool.isRequired,
}

export default LoadingIcon
